import { Competition } from 'business';
import { useQuery } from 'bridge';

export default function useClubCompetitions(clubId: string, isClubAdmin?: boolean, now?: Date) : Competition[] {

    const clubCompetitions = useQuery({ clubId: clubId, isClubAdmin: isClubAdmin, queryType: 'clubCompetitions', date: now});
    return clubCompetitions;
}

